// @flow
import * as React from 'react';
import Logo from 'components/Icons/Logo';
import {
  AnalyticsIcon,
  ReviewsIcon,
  QAIcon,
  ContentIcon,
  AccountIcon,
  AdminIcon,
  SupportIcon,
  SocialCollectionIcon,
  DashboardIcon,
} from 'components/Icons/Nav';
import { NavLink as RouterNavLink, type ContextRouter } from 'react-router-dom';
import { AuthContext } from 'ducks/auth-context';
import './Nav.scss';

export type NavRouteConfig =
  | 'sep'
  | {
      component?: React.ComponentType<*>,
      render?: () => React.Element<any>,
      path: string,
      exact?: boolean,
      strict?: boolean,
      label?: string,
      navItem?: boolean,
    };

type OwnProps = {|
  contextLabel: string,
  contextRoutes: Array<NavRouteConfig>,
  ...ContextRouter,
|};

type NavProps = OwnProps;

const NavWidth = 220;
const PortalNavWidth = 60;

export const Nav = (props: NavProps) => {
  const { contextLabel, contextRoutes, match } = props;

  return (
    <AuthContext.Consumer>
      {auth => {
        return (
          <nav
            className="w5 min-vh-100 fixed top-0 left-0 bottom-0 bg-white Nav"
            style={{ width: NavWidth }}
            data-translate={true}
          >
            <div
              className="h-100 fixed br Nav__border"
              style={{ width: PortalNavWidth }}
            >
              <ul className="list pl0 Nav__Portal flex flex-column items-center justify-center w-100">
                <li className="mv3 Nav__Portal__item--home">
                  <NavLink to={auth.apps.get('Home')}>
                    <Logo className="db center" />
                  </NavLink>
                </li>
                {[...auth.apps.entries()].slice(1).map(([label, url]) => {
                  const Icon = getAppIcon(label);

                  return (
                    <li
                      className="Nav__Portal__item flex items-center justify-center"
                      key={url}
                    >
                      <NavLink
                        to={url}
                        className="link Nav__Portal__link"
                        activeClassName="Nav__Portal__link--active"
                      >
                        {Icon && <Icon />}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div
              className="h-100 bg-white fixed br Nav__border"
              style={{
                marginLeft: PortalNavWidth,
                width: NavWidth - PortalNavWidth,
              }}
            >
              <ul className="list pl0 Nav__App brandon flex flex-column">
                <li className="mv3 Nav__App__item flex items-center justify-center">
                  <span className="f4 b ttu">{contextLabel}</span>
                </li>
                {contextRoutes
                  .filter(route => route === 'sep' || route.navItem)
                  .map(route => {
                    if (route === 'sep') {
                      return (
                        <li className="pv2" key={route}>
                          <span className="db mh3 bt Nav__border" />
                        </li>
                      );
                    }
                    const { label, path: to } = route;

                    return (
                      <li className="Nav__App__item flex" key={to}>
                        <NavLink
                          to={`${match.url}/${to}`}
                          className="link Nav__App__link"
                          activeClassName="Nav__App__link--active"
                        >
                          {label}
                        </NavLink>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </nav>
        );
      }}
    </AuthContext.Consumer>
  );
};

function getAppIcon(label: string): ?React.ComponentType<any> {
  switch (label) {
    case 'Reviews':
      return ReviewsIcon;

    case 'QA':
      return QAIcon;

    case 'Moderation':
      return ContentIcon;

    case 'Analytics':
      return AnalyticsIcon;

    case 'Setup':
      return SupportIcon;

    case 'Account':
      return AccountIcon;

    case 'Admin':
      return AdminIcon;

    case 'SocialCollection':
      return SocialCollectionIcon;

    case 'Dashboard':
      return DashboardIcon;

    default:
      return null;
  }
}

function NavLink({
  to,
  activeClassName,
  children,
  ...rest
}: {
  activeClassName?: string,
  to: string,
  children: React.Node,
}) {
  const isInternal = /^\/(?!\/)/.test(to);

  if (isInternal) {
    return (
      <RouterNavLink to={to} activeClassName={activeClassName} {...rest}>
        {children}
      </RouterNavLink>
    );
  }

  return (
    <a href={to} {...rest}>
      {children}
    </a>
  );
}

export default Nav;



// WEBPACK FOOTER //
// ./src/pages/__components__/Nav.js